/* unplugin-vue-components disabled */import { render } from "./comp8.vue?vue&type=template&id=fdf3ed2a&scoped=true"
import script from "./comp8.vue?vue&type=script&lang=js"
export * from "./comp8.vue?vue&type=script&lang=js"

import "./comp8.vue?vue&type=style&index=0&id=fdf3ed2a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdf3ed2a"]])

export default __exports__